import {
  Button,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Modal,
  Row,
  Table,
  Tooltip,
  Typography,
} from "antd";
import { useEffect, useRef, useState } from "react";
import MarketingReportService from "../../../../services/MarketingReportService";
import { ColumnsType } from "antd/es/table";
import ReusableChart from "../../CommonReport/SummaryReport/ReusableChart";
import { openNotification } from "../../../../utils";
import dayjs from "dayjs";
// import isoWeek from "dayjs/plugin/isoWeek";
// import ReactDatePicker, { registerLocale } from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { enGB } from "date-fns/locale/en-GB";
// import { CalendarOutlined } from "@ant-design/icons";
// import DateRange from "../../../Common/DateRange";

// dayjs.extend(isoWeek);
// registerLocale("en-GB", enGB);

const { Title } = Typography;

const MarketingTmOnlineCustomerVisitsAndSpendingReport = ({
  dateRange,
  periodCount,
}: {
  dateRange: any;
  periodCount: number;
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [dateLabels, setDateLabels] = useState<any[]>([]);
  const [salesCountSeries, setSalesCountSeries] = useState<any[]>([]);
  const [registrationSeries, setRegistrationSeries] = useState<any[]>([]);
  const [salesPercentageSeries, setSalesPercentageSeries] = useState<any[]>([]);
  const [conversionRateSeries, setConversionRateSeries] = useState<any[]>([]);
  const [chartHeight, setChartHeight] = useState<number>(200);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  // const [selectedWeek, setSelectedWeek] = useState<Date | null>(null);
  const [form] = Form.useForm();
  const tableRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200 && tableRef.current) {
        const tableColHeight = tableRef.current.getBoundingClientRect().height;
        setChartHeight(Math.max(200, tableColHeight - 30));
      } else {
        setChartHeight(250);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line
  }, [dataSource]);

  const handleModalOpen = () => {
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const handleDateChange = async (date: Date | null) => {
    setSelectedDate(date);

    if (!date) {
      form.resetFields();
      return;
    }

    // Seçilen tarihi dayjs nesnesine çevir
    const dateDayjs = dayjs(date);

    const startDate = dateDayjs.format("YYYY-MM-DD");
    const endDate = dateDayjs.format("YYYY-MM-DD");

    try {
      const response = await MarketingReportService.getVisitorAndExpensesWeekly(
        startDate,
        endDate
      );
      if (response.data && response.data.length > 0) {
        form.setFieldsValue({
          weeklyVisitors: response.data[0].weeklyVisitors,
          totalExpenses: response.data[0].totalExpenses,
        });
      } else {
        form.resetFields(["weeklyVisitors", "totalExpenses"]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // // Hafta seçmek için kullanılan fonksiyon
  // const handleDateChange = async (date: Date | null) => {
  //   setSelectedWeek(date);

  //   if (!date) {
  //     form.resetFields();
  //     return;
  //   }

  //   // Seçilen tarihi dayjs nesnesine çevir
  //   const dateDayjs = dayjs(date);

  //   const startDate = dateDayjs.startOf("isoWeek").format("YYYY-MM-DD");
  //   const endDate = dateDayjs.endOf("isoWeek").format("YYYY-MM-DD");

  //   try {
  //     const response = await MarketingReportService.getVisitorAndExpensesWeekly(
  //       startDate,
  //       endDate
  //     );
  //     if (response.data && response.data.length > 0) {
  //       form.setFieldsValue({
  //         weeklyVisitors: response.data[0].weeklyVisitors,
  //         totalExpenses: response.data[0].totalExpenses,
  //       });
  //     } else {
  //       form.resetFields(["weeklyVisitors", "totalExpenses"]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const handleFormSubmit = async (values: any) => {
    setLoading(true);
    try {
      const dateDayjs = dayjs(values.date);
      const startDate = dateDayjs.format("YYYY-MM-DD");
      const endDate = dateDayjs.format("YYYY-MM-DD");

      const existingData =
        await MarketingReportService.getVisitorAndExpensesWeekly(
          startDate,
          endDate
        );

      if (existingData.data.length > 0) {
        // Veri varsa PUT işlemi
        const request = {
          id: existingData.data[0].id,
          weeklyVisitors: values.weeklyVisitors,
          totalExpenses: values.totalExpenses,
        };

        await MarketingReportService.updateVisitorAndExpensesWeekly(
          request,
          existingData.data[0].id
        );
        openNotification("success", "Success", "Data updated successfully.");
      } else {
        // Veri yoksa POST işlemi
        const request = {
          reportStartDate: startDate + "T00:00:00.000Z",
          reportEndDate: endDate + "T23:59:59.999Z",
          weeklyVisitors: values.weeklyVisitors,
          totalSpending: values.totalExpenses,
        };

        await MarketingReportService.createVisitorAndExpensesWeekly(request);
        openNotification("success", "Success", "Data added successfully.");
      }

      handleModalClose();
      const periods = getPeriods(dateRange, periodCount);
      await getReports(periods);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getPeriods = (dateRange: any, periodCount: number) => {
    const periods = [];
    let start = dayjs(dateRange[0]);
    let end = dayjs(dateRange[1]);

    for (let i = 0; i < periodCount; i++) {
      const formattedStart = start.format("YYYY-MM-DD");
      const formattedEnd = end.format("YYYY-MM-DD");

      periods.push({
        start: formattedStart,
        end: formattedEnd,
        label: `${start.format("DD.MMM.YY")} - ${end.format("DD.MMM.YY")}`,
      });

      const diffDays = end.diff(start, "days") + 1;
      end = start.subtract(1, "days");
      start = end.subtract(diffDays - 1, "days");
    }

    return periods.reverse();
  };

  useEffect(() => {
    if (dateRange[0] && dateRange[1]) {
      const periods = getPeriods(dateRange, periodCount);
      getReports(periods);
      setDateLabels(periods);
    }
    // eslint-disable-next-line
  }, [dateRange, periodCount]);

  const getReports = async (periods: any[]) => {
    setLoading(true);
    try {
      const promises = periods.map((period) =>
        MarketingReportService.getMarketingReportWeekly(
          period.start,
          period.end
        )
      );

      const responses = await Promise.all(promises);

      const formattedData = responses.map((response, index) => {
        // Gelen diziyi işleyip değerleri topla
        const data = response.data || [];

        const combinedData = data.reduce(
          (acc, current) => {
            acc.weeklyVisitors += current.weeklyVisitors || 0;
            acc.totalSpending += current.totalSpending || 0;
            acc.weeklyRegistrations += current.weeklyRegistrations || 0;
            acc.directUserCount += current.directUserCount || 0;
            acc.weeklySalesCount += current.weeklySalesCount || 0;
            acc.conversionRate += current.conversionRate || 0;
            acc.salesPercentage += current.salesPercentage || 0;
            return acc;
          },
          {
            weeklyVisitors: 0,
            totalSpending: 0,
            weeklyRegistrations: 0,
            directUserCount: 0,
            weeklySalesCount: 0,
            conversionRate: 0,
            salesPercentage: 0,
          }
        );

        // Kayıt başına maliyet oranını hesapla
        const costPerRegistration =
          combinedData.totalSpending > 0
            ? combinedData.totalSpending / combinedData.weeklyRegistrations
            : 0;
        // Ortalama yüzdelik değerleri hesapla
        const avgConversionRate =
          data.length > 0 ? combinedData.conversionRate / data.length : 0;
        const avgSalesPercentage =
          data.length > 0 ? combinedData.salesPercentage / data.length : 0;

        return {
          key: index,
          date: periods[index].label,
          weeklyVisitors: combinedData.weeklyVisitors,
          costPerRegistration: parseFloat(costPerRegistration.toFixed(2)),
          directUserCount: combinedData.directUserCount,
          weeklyRegistrations: combinedData.weeklyRegistrations,
          weeklySalesCount: combinedData.weeklySalesCount,
          totalSpending: parseFloat(combinedData.totalSpending.toFixed(2)),
          avgConversionRate: parseFloat(avgConversionRate.toFixed(2)),
          avgSalesPercentage: parseFloat(avgSalesPercentage.toFixed(2)),
        };
      });

      // Tabloda görüntülenecek veriyi güncelle
      setDataSource(formattedData);

      // Grafik için verileri ayarla
      setSalesCountSeries([
        {
          name: "Sales Count",
          data: formattedData.map((item) => item.weeklySalesCount),
        },
      ]);

      setRegistrationSeries([
        {
          name: "Registration Count",
          data: formattedData.map((item) => item.weeklyRegistrations),
        },
      ]);

      setSalesPercentageSeries([
        {
          name: "Sales Percentage",
          data: formattedData.map((item) => item.avgSalesPercentage),
        },
      ]);

      setConversionRateSeries([
        {
          name: "Conversion Rate",
          data: formattedData.map((item) => item.avgConversionRate),
        },
      ]);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: "Period",
      dataIndex: "date",
      key: "date",
      align: "center",
      width: 180,
      fixed: "left",
      defaultSortOrder: "descend",
      sorter: (a: any, b: any) =>
        new Date(a.date).getTime() - new Date(b.date).getTime(),
      render: (date: string) => <b>{date ? date : "-"}</b>,
    },
    {
      title: "Visitors Count",
      dataIndex: "weeklyVisitors",
      key: "weeklyVisitors",
      align: "center",
      width: 120,
      sorter: (a: any, b: any) => a?.weeklyVisitors - b?.weeklyVisitors,
      render: (text: any) => <b>{text ? text : "0"}</b>,
    },
    {
      title: "Cost Per Registration",
      dataIndex: "costPerRegistration",
      key: "costPerRegistration",
      align: "center",
      width: 120,
      sorter: (a: any, b: any) =>
        a?.costPerRegistration - b?.costPerRegistration,
      render: (text: any) => <b>${parseFloat(text).toFixed(2)}</b>,
    },
    {
      title: "Direct User Count",
      dataIndex: "directUserCount",
      key: "directUserCount",
      align: "center",
      width: 120,
      sorter: (a: any, b: any) => a?.directUserCount - b?.directUserCount,
      render: (text: any) => <b>{text ? text : "0"}</b>,
    },
    {
      title: "Registrations",
      dataIndex: "weeklyRegistrations",
      key: "weeklyRegistrations",
      align: "center",
      width: 120,
      sorter: (a: any, b: any) =>
        a?.weeklyRegistrations - b?.weeklyRegistrations,
      render: (text: any) => <b>{text ? text : "0"}</b>,
    },
    {
      title: "Total Sales",
      dataIndex: "weeklySalesCount",
      key: "weeklySalesCount",
      align: "center",
      width: 120,
      sorter: (a: any, b: any) => a?.weeklySalesCount - b?.weeklySalesCount,
      render: (text: any) => <b>{text ? text : "0"}</b>,
    },
    {
      title: "Total Expenses",
      dataIndex: "totalSpending",
      key: "totalSpending",
      align: "center",
      width: 120,
      sorter: (a: any, b: any) => a?.totalSpending - b?.totalSpending,
      render: (text: any) => <b>${parseFloat(text).toFixed(2)}</b>,
    },
    {
      title: "Conversion Rate",
      dataIndex: "avgConversionRate",
      key: "avgConversionRate",
      align: "center",
      width: 120,
      sorter: (a: any, b: any) => a?.avgConversionRate - b?.avgConversionRate,
      render: (text: any) => <b>{text ? text.toFixed(2) : "0.00"}%</b>,
    },
    {
      title: "Sales Percentage",
      dataIndex: "avgSalesPercentage",
      key: "avgSalesPercentage",
      align: "center",
      width: 120,
      sorter: (a: any, b: any) => a?.avgSalesPercentage - b?.avgSalesPercentage,
      render: (text: any) => <b>{parseFloat(text).toFixed(2)}%</b>,
    },
  ];

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 40, marginTop: 20 }}>
      <Col span={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={24} xxl={24} style={{ textAlign: "right" }}>
            <Button type="primary" onClick={handleModalOpen}>
              Add/Update Daily Data
            </Button>
          </Col>
          <Col xs={24} xl={24} xxl={24} ref={tableRef}>
            <Table
              rowKey={(record) => record?.key}
              loading={loading}
              dataSource={dataSource}
              columns={columns}
              scroll={{ x: "100%" }}
              pagination={false}
              tableLayout="fixed"
              summary={(pageData) => {
                // Toplam değerleri hesaplama
                const totalVisitors = pageData.reduce(
                  (sum, record) => sum + record.weeklyVisitors,
                  0
                );
                const totalRegistrations = pageData.reduce(
                  (sum, record) => sum + record.weeklyRegistrations,
                  0
                );
                const totalDirectUserCount = pageData.reduce(
                  (sum, record) => sum + record.directUserCount,
                  0
                );
                const totalSalesCount = pageData.reduce(
                  (sum, record) => sum + record.weeklySalesCount,
                  0
                );
                const totalSpending = pageData.reduce(
                  (sum, record) => sum + record.totalSpending,
                  0
                );

                // Ortalama yüzdelik değerler
                const avgConversionRate =
                  pageData.length > 0
                    ? pageData.reduce(
                        (sum, record) => sum + record.avgConversionRate,
                        0
                      ) / pageData.length
                    : 0;

                const avgSalesPercentage =
                  pageData.length > 0
                    ? pageData.reduce(
                        (sum, record) => sum + record.avgSalesPercentage,
                        0
                      ) / pageData.length
                    : 0;

                // Kayıt başına maliyet hesaplama
                const costPerRegistration =
                  totalRegistrations > 0
                    ? totalSpending / totalRegistrations
                    : 0;

                return (
                  <Table.Summary fixed>
                    <Table.Summary.Row className="summary-cell">
                      <Table.Summary.Cell
                        index={0}
                        align="center"
                        className="summary-cell"
                      >
                        <b>Total</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={1}
                        align="center"
                        className="summary-cell"
                      >
                        <b>{totalVisitors}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={2}
                        align="center"
                        className="summary-cell"
                      >
                        <Tooltip title="Average Cost per Registration">
                          <b>${costPerRegistration.toFixed(2)}</b>
                        </Tooltip>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={3}
                        align="center"
                        className="summary-cell"
                      >
                        <b>{totalDirectUserCount}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={4}
                        align="center"
                        className="summary-cell"
                      >
                        <b>{totalRegistrations}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={5}
                        align="center"
                        className="summary-cell"
                      >
                        <b>{totalSalesCount}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={6}
                        align="center"
                        className="summary-cell"
                      >
                        <b>${totalSpending.toFixed(2)}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={7}
                        align="center"
                        className="summary-cell"
                      >
                        <b>{avgConversionRate.toFixed(2)}%</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={8}
                        align="center"
                        className="summary-cell"
                      >
                        <b>{avgSalesPercentage.toFixed(2)}%</b>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </Table.Summary>
                );
              }}
            />
          </Col>
          <Col xs={24} xl={24} xxl={12}>
            <Title level={4}>Registration Chart</Title>
            <ReusableChart
              type="area"
              series={registrationSeries}
              categories={dateLabels.map((label) => label.label)}
              height={chartHeight}
            />
          </Col>
          <Col xs={24} xl={24} xxl={12}>
            <Title level={4}>Sales Chart</Title>
            <ReusableChart
              type="area"
              series={salesCountSeries}
              categories={dateLabels.map((label) => label.label)}
              height={chartHeight}
            />
          </Col>
          <Col xs={24} xl={24} xxl={12}>
            <Title level={4}>Sales Percentage Chart</Title>
            <ReusableChart
              type="area"
              series={salesPercentageSeries}
              categories={dateLabels.map((label) => label.label)}
              height={chartHeight}
            />
          </Col>
          <Col xs={24} xl={24} xxl={12}>
            <Title level={4}>Conversion Rate Chart</Title>
            <ReusableChart
              type="area"
              series={conversionRateSeries}
              categories={dateLabels.map((label) => label.label)}
              height={chartHeight}
            />
          </Col>
        </Row>
      </Col>
      <Modal
        title="Add or Update Daily Data"
        open={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
        width={"35rem"}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFormSubmit}
          initialValues={{ weeklyVisitors: null, totalExpenses: null }}
        >
          <Row gutter={[8, 8]}>
            {/* Tarih Seçimi */}
            <Col xs={24} sm={8}>
              <Form.Item
                name="date"
                label="Select Day"
                rules={[{ required: true, message: "Please select a day!" }]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  value={selectedDate}
                  onChange={handleDateChange}
                />
                {/* Haftalık tarih seçimi */}
                {/* <ReactDatePicker
                  showIcon
                  locale="en-GB"
                  showWeekNumbers
                  showWeekPicker
                  dateFormat="wo 'of' yyyy"
                  selected={selectedWeek}
                  onChange={(date: Date | null) => {
                    handleDateChange(date);
                    form.setFieldsValue({ date });
                  }}
                  placeholderText="Select a week"
                  customInput={
                    <Input
                      placeholder="Select a week"
                      prefix={<CalendarOutlined />}
                    />
                  }
                  popperClassName="custom-react-datepicker"
                /> */}
              </Form.Item>
            </Col>

            {/* İki input yan yana */}
            <Col xs={24} sm={8}>
              <Form.Item
                name="weeklyVisitors"
                label="Daily Visitors"
                rules={[
                  { required: true, message: "Please enter visitors count!" },
                ]}
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                name="totalExpenses"
                label="Total Expenses ($)"
                rules={[
                  { required: true, message: "Please enter total expenses!" },
                ]}
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </Row>
  );
};

export default MarketingTmOnlineCustomerVisitsAndSpendingReport;
